import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { Router } from "react-router-dom"
import axios from 'axios';
import { applyMiddleware, createStore } from 'redux';
import reducer from "./_reducers";
import { Provider } from "react-redux";
import history from "./history";
import thunk from "redux-thunk";
import { BASE_URL } from "./constants/constants";
import * as Sentry from "@sentry/react";
import moment from "moment";

if (process.env.NODE_ENV !== "development" && process.env.NODE_ENV !== "dev") {
    console.log = () => { };
    if (process.env.REACT_APP_SENTRY_DSN) {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", new RegExp(`^${process.env.REACT_APP_API_BASE_URL}`)],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }
}
const store = createStore(reducer, applyMiddleware(
    thunk,
));

axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.common['timezone'] = moment().utcOffset()

// Global error reporting for runtime errors and unhandled promise rejections
if (typeof window !== 'undefined') {
    window.addEventListener('error', function (event) {
        try {
            const payload = {
                message: event.error && event.error.message ? event.error.message : (event.message || 'window error'),
                stack: event.error && event.error.stack ? event.error.stack : null,
                filename: event.filename || null,
                lineno: event.lineno || null,
                colno: event.colno || null,
                url: window.location.href,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString()
            };
            axios.post('/api/client-error', payload).catch(() => { });
        } catch (e) { }
        try {
            if (Sentry && typeof Sentry.captureException === 'function') {
                Sentry.captureException(event.error || event.message);
            }
        } catch (e) { }
    });

    window.addEventListener('unhandledrejection', function (event) {
        try {
            const reason = event.reason;
            const payload = {
                message: reason && reason.message ? reason.message : (String(reason) || 'unhandledrejection'),
                stack: reason && reason.stack ? reason.stack : null,
                url: window.location.href,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString()
            };
            axios.post('/api/client-error', payload).catch(() => { });
        } catch (e) { }
        try {
            if (Sentry && typeof Sentry.captureException === 'function') {
                Sentry.captureException(event.reason);
            }
        } catch (e) { }
    });
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router history={history}>
                <I18nextProvider i18n={i18n}>
                    <App />
                </I18nextProvider>
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals();
